import { tsrContractsClient } from '../tsrContractsClient';

export const createConsultationPaymentRequestClient = () => tsrContractsClient.consultationContract;
